import React from 'react';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';

import { RSVP_STYLES } from './attendance.helpers';

interface IRsvpSummaryCellProps {
  // Defined → render counts. Undefined → attendance is disabled for this row,
  // render a single em-dash. The two states must be visually distinct so that
  // "all pending" never looks the same as "RSVPs disabled."
  counts?: IAttendanceCounts;
}

// NOTE: This cell uses `<Box>` (default element: `<div>`) rather than `<span>`.
// The parent `TableCell` applies a global
// `& span { position: absolute; left: 0; right: 0; overflow: hidden; }`
// rule that clips any nested span content to invisible. Divs sidestep that;
// keep this component span-free.
export const RsvpSummaryCell: React.FC<IRsvpSummaryCellProps> = ({ counts }) => {
  if (!counts) {
    return <Box style={{ color: 'rgba(0, 0, 0, 0.4)' }}>—</Box>;
  }

  const tooltip = `${counts.attending} attending · ${counts.pending} pending · ${counts.notAttending} not attending · ${counts.total} total`;

  return (
    <Tooltip title={tooltip}>
      <Box
        display="inline-flex"
        alignItems="center"
        style={{ whiteSpace: 'nowrap' }}
      >
        <Box style={{ color: RSVP_STYLES.attending.color, fontWeight: 600 }}>
          {counts.attending}
        </Box>
        <Box style={{ color: 'rgba(0, 0, 0, 0.4)', fontWeight: 600 }}>/</Box>
        <Box style={{ color: RSVP_STYLES.pending.color, fontWeight: 600 }}>
          {counts.pending}
        </Box>
        <Box style={{ color: 'rgba(0, 0, 0, 0.4)', fontWeight: 600 }}>/</Box>
        <Box style={{ color: RSVP_STYLES.not_attending.color, fontWeight: 600 }}>
          {counts.notAttending}
        </Box>
      </Box>
    </Tooltip>
  );
};

